<template>
    <div>
        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-between">
                <div class="d-md-flex">
                    <h3>Pending Commision Summary</h3>
                </div>
                <div class="d-flex justify-content-md-between align-items-bottom">
                    <p class="mx-2">Total Net Pay:</p>
                    <router-link :to="'#'" class="font-weight-500 mb-0 text-primary">
                        <h3 class="text-primary">
                            RM42,500.00
                        </h3>
                    </router-link>
                </div>
            </b-row>
        </b-col>
        <div class="table-simple-modal">
            <b-table-simple responsive borderless>
                <b-thead>
                    <b-tr>
                        <b-th>#</b-th>
                        <b-th>Date</b-th>
                        <b-th>Customer<br>Name</b-th>
                        <b-th>Product<br>Details</b-th>
                        <b-th>Sales (RM)</b-th>
                        <b-th>Comm.<br>Rate(%)</b-th>
                        <b-th>Revenue<br>Point</b-th>
                        <b-th>Payout<br>(85%)</b-th>
                        <b-th>Override<br>Mar.</b-th>
                        <b-th>Total<br>Comm.</b-th>
                        <b-th>UTD Rel.<br>(%)</b-th>
                        <b-th>Current<br>Rel.</b-th>
                        <b-th>Balance<br>Comm.</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in tableData" :key="index">
                        <b-td>{{ index + 1 }}</b-td>
                        <b-td>{{ item.date }}</b-td>
                        <b-td>{{ item.customer_name }}</b-td>
                        <b-td>
                            <el-button type="text" class="d-inline-block text-truncate py-0" style="max-width: 120px;">
                                {{ item.product_details }}
                            </el-button>
                        </b-td>
                        <b-td>{{ item.sales | moneyFormatter }}</b-td>
                        <b-td>{{ item.commission_rate }}</b-td>
                        <b-td>{{ item.revenue_point | moneyFormatter }}</b-td>
                        <b-td>{{ item.payout | moneyFormatter }}</b-td>
                        <b-td>{{ item.override_margin }}</b-td>
                        <b-td>{{ item.total_comm | moneyFormatter }}</b-td>
                        <b-td>{{ item.utd_rel }}</b-td>
                        <b-td>{{ item.current_rel | moneyFormatter }}</b-td>
                        <b-td>{{ item.balance_comm || '-' | moneyFormatter }}</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </div>
    </div>
</template>
<script>
import { Table, TableColumn, Button } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import { debounce } from '@/assets/js/httpImports.js'

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Button.name]: Button
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch:['name'],
            currentPage: 1,
            mode: 'listing',
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            tableData: 
            [
                {
                    date: '18 Dec 2022',
                    customer_name: 'Jazz Ng',
                    product_details: 'KOHATA',
                    sales: 600000,
                    commission_rate: 20,
                    revenue_point: 120000,
                    payout: 102000,
                    override_margin: 10,
                    total_comm: 10200,
                    utd_rel: 25,
                    current_rel: 2550,
                    balance_comm: 7650
                },
            ]
        }
    },
    created() {
        //
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
    },
    methods: {
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
            this.pagination.currentPage = page
        }
    }
}
</script>